import { SUBJECT_THEMES } from "./data/mockData";

/** Bảng màu cố định (Tailwind) — dùng khi tên môn không khớp map cũ */
const PALETTE = [
  { bg: "bg-indigo-50", text: "text-indigo-800", border: "border-indigo-300", accent: "#4F46E5" },
  { bg: "bg-rose-50", text: "text-rose-800", border: "border-rose-300", accent: "#E11D48" },
  { bg: "bg-emerald-50", text: "text-emerald-800", border: "border-emerald-300", accent: "#10B981" },
  { bg: "bg-sky-50", text: "text-sky-800", border: "border-sky-300", accent: "#0EA5E9" },
  { bg: "bg-amber-50", text: "text-amber-800", border: "border-amber-300", accent: "#D97706" },
  { bg: "bg-violet-50", text: "text-violet-800", border: "border-violet-300", accent: "#7C3AED" },
  { bg: "bg-fuchsia-50", text: "text-fuchsia-800", border: "border-fuchsia-300", accent: "#C026D3" },
  { bg: "bg-cyan-50", text: "text-cyan-800", border: "border-cyan-300", accent: "#0891B2" },
];

function hashString(s) {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = Math.imul(31, h) + s.charCodeAt(i) | 0;
  }
  return Math.abs(h);
}

/**
 * Màu theo môn: ưu tiên map tĩnh, sau đó chứa từ khóa, cuối cùng hash theo subject_id / tên.
 */
export function getSubjectTheme(ev) {
  const name = (ev?.subject || "").trim();
  if (name && SUBJECT_THEMES[name]) return SUBJECT_THEMES[name];

  const lower = name.toLowerCase();
  for (const key of Object.keys(SUBJECT_THEMES)) {
    if (key === "default") continue;
    const k = key.toLowerCase();
    if (lower && (lower.includes(k) || k.includes(lower))) return SUBJECT_THEMES[key];
  }

  const seed = ev?.subject_id ? String(ev.subject_id) : name || String(ev?.class_id || "") || "x";
  return PALETTE[hashString(seed) % PALETTE.length];
}

export function formatScheduleEventHint(ev) {
  if (!ev) return "";
  const pad2 = (n) => String(n ?? "").padStart(2, "0");
  const lines = [
    `Lớp: ${ev.class || "—"}`,
    `Khóa học: ${ev.course || "—"}`,
    `Môn: ${ev.subject || "—"}`,
    `Giáo viên: ${ev.teacher || "—"}`,
    `Phòng: ${ev.room || "—"}`,
    `Cơ sở: ${ev.branch || "—"}`,
    `Giờ: ${pad2(ev.start)}:00 – ${pad2(ev.end)}:00`,
  ];
  if (ev.start_date && ev.end_date) {
    lines.push(`Hiệu lực: ${ev.start_date} → ${ev.end_date}`);
  } else if (ev.start_date) {
    lines.push(`Từ ngày: ${ev.start_date}`);
  } else if (ev.end_date) {
    lines.push(`Đến ngày: ${ev.end_date}`);
  }
  return lines.join("\n");
}
